import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["storeAvailabilities"];

  declare storeAvailabilitiesTarget : HTMLButtonElement;

  toggleAvailabilities() : void {
    this.storeAvailabilitiesTarget.classList.toggle("is-hidden");
  }
}
